module.exports = __webpack_public_path__ + "img/PHYSICAL_TRAINING.a7fe0068.webp";